import { UserRoleHeading } from "@/components/Layout/Parts";
import FreelancersTable from "./components/FreelancersTable";

const FreelancersList = () => {
  return (
    <>
      <UserRoleHeading />
      <FreelancersTable />
    </>
  );
};

export default FreelancersList;
